import React from 'react';
import { Grid, TextField, FormHelperText, Alert, Box } from '@mui/material';

const DynamicAttributeFields = ({
  value = {},
  onChange,
  formData = {},
  sourceField,
  helperText,
  error,
  errorText,
  disabled = false,
}) => {
  // Get the variant attributes from formData
  const variantAttributes = formData[sourceField] || [];
  
  // If no attributes are defined, show info message
  if (!variantAttributes || variantAttributes.length === 0) {
    return (
      <Box>
        <Alert severity="info" sx={{ mb: 2 }}>
          <strong>No variant attributes defined yet.</strong><br/>
          Please add variant attributes above first. Once you add attributes like "Color" or "Size", 
          individual input fields will appear here for each variant.
        </Alert>
      </Box>
    );
  }

  // Handle individual field changes
  const handleFieldChange = (attributeName, fieldValue) => {
    const newValue = {
      ...value,
      [attributeName]: fieldValue
    };
    onChange(newValue);
  };

  // Generate description for each attribute
  const getDescription = (attributeName) => {
    const descriptions = {
      'Color': 'Please enter the color',
      'Storage Capacity': 'Please enter the storage capacity',
      'RAM Size': 'Please enter the RAM size',
      'Screen Size': 'Please enter the screen size',
      'Model Variant': 'Please enter the model variant',
      'Network Type': 'Please enter the network type',
      'Battery Capacity': 'Please enter the battery capacity',
      'Carrier': 'Please enter the carrier',
      'Processor Type': 'Please enter the processor type',
      'Region/Market': 'Please enter the region/market'
    };
    return descriptions[attributeName] || `Please enter the ${attributeName.toLowerCase()}`;
  };

  return (
    <Box>
      <Grid container spacing={2}>
        {variantAttributes.map((attribute, index) => {
          const attributeName = attribute['Attribute Name'];
          if (!attributeName) return null;
          
          return (
            <Grid size={{ xs: 12, sm: 6, md: 6 }} key={index}>
              <TextField
                fullWidth
                label={attributeName}
                value={value[attributeName] || ''}
                onChange={(e) => handleFieldChange(attributeName, e.target.value)}
                placeholder={`Enter ${attributeName.toLowerCase()}...`}
                disabled={disabled}
                error={error}
                helperText={getDescription(attributeName)}
                variant="outlined"
              />
            </Grid>
          );
        })}
      </Grid>
      
      {helperText && (
        <FormHelperText sx={{ mt: 1 }}>
          {helperText}
        </FormHelperText>
      )}
      
      {error && errorText && (
        <FormHelperText error sx={{ mt: 1 }}>
          {errorText}
        </FormHelperText>
      )}
    </Box>
  );
};

export default DynamicAttributeFields;



